import { TCampaignSummary } from "domain/entities/campaign-summary-response";
import { TSummaryResponse } from "domain/entities/generic-type";

export class CampaignSummaryModel {
  static from(campaignSummaryresponse: TSummaryResponse): TCampaignSummary {
    return {
      cards: campaignSummaryresponse.cards,
      range: campaignSummaryresponse.range,
      summary: {
        dataColumns: [
          {
            header: 'Campaign',
            accessor: 'name',
          },
          {
            header: "Visitors",
            accessor: "visitors"
          },
          {
            header: "Converted",
            accessor: "converted"
          },
          {
            header: "Bounced",
            accessor: "bounced"
          },
          {
            header: "Avg. Time",
            accessor: "averageTime"
          },
          {
            header: "UTM",
            accessor: "utm"
          },
        ],
        dataRows: campaignSummaryresponse.table.map(
          (campaignSummary) => {
            return {
              name : campaignSummary.name,
              visitors: `${campaignSummary.visitors} (${campaignSummary.visitorsPercentage}%)`,
              converted: `${campaignSummary.converted} (${campaignSummary.convertedPercentage}%)`,
              bounced: `${campaignSummary.bounced} (${campaignSummary.bouncedPercentage}%)`,
              averageTime: campaignSummary.averageTime,
              utm: campaignSummary.utm,
            };
          }
        ),
      }
    }
  }
}
